import React from "react";
// import personalizedHero from "../../commonImages/personalized-mini.png";
import { useNavigate } from "react-router";
import { updateQueryParams } from "../../utils/commanFunctions";
import configs from "../../contentConfig";
import { trackWidgetClick } from "../../utils/FunctionsForGa";

const content = configs?.explore?.personaliseYourStay?.content || {};
const mainImage = configs?.explore?.personaliseYourStay?.imgSrc || "";
const selectedFilter = JSON.parse(localStorage.getItem("selectedFilter"))
const handleGA = ()=>{
      if(process.env.REACT_APP_GA_ENABLED==="true"){
        const ga_payload = {
          action:selectedFilter,
          type: "Personalize Your Stay Widget",
          widget_name:"Personalize Your Stay",
          isFavorite: false,
        }
    
        trackWidgetClick(ga_payload)
      }
     }


const PersonalizedCard = () => {
  const navigate = useNavigate();
  return (
    <div class="personalized-redirection-card w-[100%] px-4 pb-8" onClick={(e) => {
      e.stopPropagation();
      handleGA()
       const path = updateQueryParams({
         path: "personalizedStay",
       });
       navigate(path);
    }}>
      <div class="h-[18px] personalized-redirection-card-top-text gap-2 font-bold">
        CURATED BY YOU
      </div>
      <div class="flex items-center pt-4 pb-4 personalized-redirection-card-inner-box ">
      <div
  className="w-[64px] h-[64px] bg-cover bg-center personalized-card-image"
  role="img"
  aria-label="Curated options"
/>

        <div class="flex-1 ml-4 personalized-card-text-box">
          <div class="text-[18px] leading-[26px] w-[241px] h-[26px]">
            <h2 class="pers-stay-card-heading">{content.title|| "Personalize Your Stay"}</h2>
          </div>

          <div class="text-[14px] h-[36px] personalized-card-text-box-subtext  text-black">
            <p>{content.subTitle || "Use our AI wizard to curate your stay"}</p>
          </div>
        </div>

        <div class="ml-4 cursor-pointer personalized-card-icon" >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 12.0002L22 12.0227M22 12.0227C16.7507 12.8069 13 16.2873 13 20.0002M22 12.0227C16.7347 11.2385 13 7.71318 13 4.00024"
              stroke="black"
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linejoin="bevel"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default PersonalizedCard;
